module.exports = __webpack_public_path__ + "Icono_CXSurtida_512px.png";